<template>
	<v-container grid-list-xs class="pa-0">
		<v-layout row wrap>
			<v-container>
				<v-flex xs12 md12>
					<v-card>
						<v-card-title primary-title>
							{{ $t("title.order") }}
							<v-spacer></v-spacer>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<v-simple-table>
								<thead>
									<tr>
										<th class="text-left">
											{{ $t("Date") }}
										</th>
										<th class="text-left">
											{{ $t("Customer") }}
										</th>
										<th class="text-left">
											{{ $t("Outlet") }}
										</th>
										<th class="text-left">
											{{ $t("Price") }}
										</th>
										<th class="text-left">
											{{ $t("label.quantity") }}
										</th>
										<th class="text-left">
											{{ $t("Status") }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(data, index) in data.orders"
										:key="index"
									>
										<td>{{ data.datetime }}</td>
										<td>{{ data.customer_name }}</td>
										<td>{{ data.outlet_name }}</td>
										<td>{{ data.balance | currency }}</td>
										<td>{{ data.total_order }}</td>

										<td>
											<v-btn
												v-if="data.status == 'pending'"
												color="warning"
												class="white--text"
												small
												>{{ data.status }}
											</v-btn>
											<v-btn
												v-else-if="
													data.status == 'delivering'
												"
												color="primary"
												class="white--text"
												small
												>{{ data.status }}
											</v-btn>
											<v-btn
												v-else-if="
													data.status == 'delivered'
												"
												color="blue-grey"
												class="white--text"
												small
												>{{ data.status }}
											</v-btn>
											<v-btn
												v-else-if="
													data.status == 'completed'
												"
												color="indigo"
												class="white--text"
												small
												>{{ data.status }}
											</v-btn>
											<v-btn
												v-else-if="
													data.status == 'canceled'
												"
												color="red"
												class="white--text"
												small
												>{{ data.status }}
											</v-btn>
											<v-btn
												v-else-if="
													data.status == 'accepted'
												"
												color="success"
												class="white--text"
												small
											>
												{{ data.status }}
											</v-btn>
										</td>
									</tr>
								</tbody>
							</v-simple-table>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs12 md12 class="pt-8">
					<v-card>
						<v-card-title primary-title>
							{{ $t("title.reservation") }}
							<v-spacer></v-spacer>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<v-simple-table>
								<thead>
									<tr>
										<th class="text-left">
											{{ $t("title.order") }}
										</th>
										<th class="text-left">
											{{ $t("Customer") }}
										</th>
										<th class="text-left">
											{{ $t("Outlet") }}
										</th>
										<th class="text-left">
											{{ $t("Time") }}
										</th>
										<th class="text-left">
											{{ $t("Date") }}
										</th>
										<th class="text-left">
											{{ $t("label.adults") }}
										</th>
										<th class="text-left">
											{{ $t("label.children") }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(
											data, index
										) in data.daily_reservations"
										:key="index"
									>
										<th>{{ data.orders }}</th>
										<th>
											{{ data.customer.display_name }}
										</th>
										<td>{{ data.outlet_name }}</td>
										<td>{{ data.time }}</td>
										<td>{{ data.datetime }}</td>
										<td>{{ data.adults }}</td>
										<td>{{ data.children }}</td>
									</tr>
								</tbody>
							</v-simple-table>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-container>
		</v-layout>
	</v-container>
</template>
<script>
import TenantLayout from "../../../layouts/tenant.vue";
import TenantReportLayout from "../../../layouts/partials/tenant/report.vue";
import { Link } from "@inertiajs/inertia-vue";
export default {
	layout: [TenantLayout, TenantReportLayout],
	components: {
		Link,
	},
	props: ["data", "total_order", "orders"],
	data() {
		return {
			loading: false,
			dialog: false,
			datas: [],
			datas: [],
		};
	},

	methods: {},
};
</script>